import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';

const Breadcrumb = ({ currentView, setCurrentView }) => {
  const viewToName = {
    "landing": "Home",
    "input": "Calculate",
    "results": "Results",
    "dashboard": "Dashboard",
    "insights": "Insights",
    "challenges": "Challenges",
    "goals": "Goals",
    "shop": "Shop",
    "blog": "Blog",
    "quiz-hub": "Quizzes"
  };

  const pathArray = [];
  let currentPath = '';

  // If it's a child view, include parent views in breadcrumb
  if (currentView !== "landing") {
    pathArray.push({ name: "Home", path: "landing" });
    
    // Handle nested paths if needed
    if (currentView.includes('-')) {
      const segments = currentView.split('-');
      if (segments[0] === "quiz" && segments.length > 1) {
        pathArray.push({ name: "Quizzes", path: "quiz-hub" });
      }
    }
    
    // Add current path
    pathArray.push({ name: viewToName[currentView] || currentView, path: currentView });
  }

  // Create schema markup for breadcrumbs
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": pathArray.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `https://guiltgauge.com/${item.path === "landing" ? "" : item.path}`
    }))
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>

      {pathArray.length > 1 && (
        <motion.div 
          className="w-full max-w-md mx-auto mb-4 text-sm text-gray-600 dark:text-gray-400"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <nav>
            <ol className="flex flex-wrap">
              {pathArray.map((item, index) => (
                <li key={item.path} className="flex items-center">
                  {index > 0 && <span className="mx-2">/</span>}
                  {index === pathArray.length - 1 ? (
                    <span>{item.name}</span>
                  ) : (
                    <button 
                      onClick={() => setCurrentView(item.path)}
                      className="hover:text-blue-500 dark:hover:text-blue-400"
                    >
                      {item.name}
                    </button>
                  )}
                </li>
              ))}
            </ol>
          </nav>
        </motion.div>
      )}
    </>
  );
};

export default Breadcrumb;
